import { readPointUserLedgerList } from '@/api/point/read';
import { ResReadPointUserLedgerListType, ResReadPointUserListType } from '@/types';
import { Box, Button, Card, CardContent, Divider } from '@mui/material';
import { useEffect, useState } from 'react';
import Header from '../../Header';
import { Tables } from '../../pools/table/Tables';
import { pointUserLedgerListColumns } from '../table/ColumnData';

import { useNavigate } from 'react-router-dom';
import { packBigNumbers } from '@/lib/BigNumbers';
import { pointLedgerStatusFilter } from '@/lib/filter/points';

export default function UserLedgerList() {
  const [list, setList] = useState<ResReadPointUserListType[]>([]);
  const navigate = useNavigate();

  // const handleButtonClick = (aData: string) => {
  //   const src =
  //     process.env.NODE_ENV === 'development'
  //       ? `https://amoy.polygonscan.com/tx/${aData}`
  //       : `https://polygonscan.com/tx/${aData}`;
  //   window.open(src);
  // };

  useEffect(() => {
    (async () => {
      const re = await readPointUserLedgerList();
      if (re.status !== 200) {
        return;
      }
      const list = re.data.map((item: ResReadPointUserLedgerListType, index: number) => ({
        ...item,
        index,
        amount: packBigNumbers(item.amount.toString()),
        status: pointLedgerStatusFilter(item.status),
      }));
      setList(list);
      console.log(re.data);
    })();
    return () => {};
  }, []);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          overflow: 'auto',
          flex: 1,
          flexDirection: 'column',
          gap: { xs: '16px', sm: '0px' },
        }}
      >
        <Card>
          <Header title="유저 원장 리스트" />
          <Divider />
          <CardContent
            sx={{
              maxHeight: 1024, // 원하는 높이(px)로 조정
              overflow: 'auto',
            }}
          >
            {list && <Tables list={list} columns={pointUserLedgerListColumns} />}
          </CardContent>
        </Card>
      </Box>
    </>
  );
}
